// extracted by mini-css-extract-plugin
export default {"container":"EntityTypeSelector_container__9T1E6","title":"EntityTypeSelector_title__S2ESk"};